module.exports = __webpack_public_path__ + "img/patent.fdc58df7.svg";